module.exports = __webpack_public_path__ + "img/usdt.3425019d.png";